// extracted by mini-css-extract-plugin
export default {"workSpacePage":"WorkSpacePage_workSpacePage__plI59","overlay":"WorkSpacePage_overlay__08WfY","mainContent":"WorkSpacePage_mainContent__mv2nM"};